import React from "react";
import {
  FaBootstrap,
  FaHtml5,
  FaGithub,
  FaGitlab,
  FaLinkedinIn,
  FaReact,
  FaCss3Alt,
  FaJs,
} from "react-icons/fa";
import { SupabaseIcon } from "./SupabaseIcon";

import { TbBrandReactNative, TbBrandTailwind } from "react-icons/tb";

const Media = () => {
  return (
    <div className="flex flex-col xl:flex-row  gap-6 lgl:gap-0 justify-between">
      <div className={"mr-12"}>
        <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
        <div className="flex gap-6">
          <span className="bannerIcon" title={"LinkedIn"}>
            <a
              href="https://www.linkedin.com/in/roshan-patil-3b3671235"
              target={"_blank"}
              rel="noreferrer"
            >
              <FaLinkedinIn />
            </a>
          </span>
          <span className="bannerIcon" title={"Gitlab"}>
            <a
              href="https://gitlab.com/roshanpatil2000"
              target={"_blank"}
              rel="noreferrer"
            >
              <FaGitlab />
            </a>
          </span>
          <span className="bannerIcon" title={"Github"}>
            <a
              href="https://github.com/roshanpatil2000"
              target={"_blank"}
              rel="noreferrer"
            >
              <FaGithub />
            </a>
          </span>
        </div>
      </div>
      <div className="flex-col ">
        <h2 className="text-base uppercase font-titleFont mb-4">
          BEST SKILL ON
        </h2>
        <div className="flex gap-6  flex-wrap">
          <span className="bannerIcon" title={"HTML"}>
            <FaHtml5 />
          </span>
          <span className="bannerIcon" title={"CSS"}>
            <FaCss3Alt />
          </span>
          <span className="bannerIcon" title={"JavaScript"}>
            <FaJs />
          </span>
          <span className="bannerIcon" title={"React"}>
            <FaReact />
          </span>
          <span className="bannerIcon" title={"React Native"}>
            <TbBrandReactNative />
          </span>
          <span className="bannerIcon" title={"Bootstrap"}>
            <FaBootstrap />
          </span>
          <span className="bannerIcon" title={"Tailwind CSS"}>
            <TbBrandTailwind />
          </span>
          <span className="bannerIcon" title={"Supabase"}>
            {/* <RiSupabaseLine /> */}
            <SupabaseIcon />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Media;
